import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MedicosDominioComponent } from './medicos-dominio/medicos-dominio.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PoModule } from '@po-ui/ng-components';
import { PoPageDynamicEditModule, PoPageDynamicTableModule } from '@po-ui/ng-templates';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  declarations: [
    MedicosDominioComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    PoModule,
    PoPageDynamicTableModule,
    PoPageDynamicEditModule,
    SharedModule
  ]
})
export class MedicosDominioModule { }
